import { UseQueryModalReturn } from "../../types";

interface UseTextQueryModalParams {
  inputValue: string | null;
  previousValue?: string | null;
  editQueryId?: string;
  existingQueryId?: string;
}

export function useTextQueryModal({
  inputValue,
  previousValue,
  editQueryId,
  existingQueryId,
}: UseTextQueryModalParams): UseQueryModalReturn {
  const isSubmitDisabled =
    inputValue?.length === 0 ||
    !!(editQueryId && inputValue === previousValue) ||
    !!(!editQueryId && existingQueryId && inputValue === previousValue);

  return { isSubmitDisabled };
}
